module.exports = __webpack_public_path__ + "static/musee_olympique_stades5-87543527f1ff1ad2fbcb51360b9926e4.png";